<template>
  <vs-row>
    <vs-row vs-type="flex" vs-justify="center">
        <vs-button class="mb-1" color="success" type="gradient" icon="add" @click="addMenuItem()">Új étel felvitele</vs-button>
    </vs-row>
    <vs-row vs-type="flex" vs-justify="center">
      <h4>{{ formatDate(selected.MenuDate) }}</h4>
    </vs-row>
    <!-- <vs-row>
      <vs-select autocomplete placeholder="Válasszon levest" label="Leves" v-model="selected.IdSoup">
        <vs-select-item :value="null" text="Nincs leves"/>
        <vs-select-item :key="index" :value="item.ItemId" :text="item.ItemName" v-for="(item, index) in itemData"/>
      </vs-select>
      <vs-input 
      v-if="selected.IdSoup" 
      v-model="SoupEcommerceCodeInput"
      placeholder="Leves e-kereskedelmi kód"
      @input="formatEcommerceCode('Soup')"

    />
    </vs-row> -->
    <vs-row>
      <vs-select autocomplete placeholder="Válasszon A menüt" label="Menü A" v-model="selected.IdMainA">
        <vs-select-item :value="null" text="Nincs A menü"/>
        <vs-select-item :key="index" :value="item.ItemId" :text="item.ItemName" v-for="(item, index) in itemData"/>
      </vs-select>
      <vs-input 
      v-if="selected.IdMainA" 
      placeholder="A Menü e-kereskedelmi kód"
      v-model="MainAEcommerceCodeInput"
      @input="formatEcommerceCode('MainA')"

    />
    </vs-row>
    <vs-row>
      <vs-select autocomplete placeholder="Válasszon B menüt" label="Menü B" v-model="selected.IdMainB">
        <vs-select-item :value="null" text="Nincs B Menü"/>
        <vs-select-item :key="index" :value="item.ItemId" :text="item.ItemName" v-for="(item, index) in itemData"/>
      </vs-select>
      <vs-input 
      v-if="selected.IdMainB" 
      placeholder="B Menü e-kereskedelmi kód" 
      v-model="MainBEcommerceCodeInput"
      @input="formatEcommerceCode('MainB')"

    />
    </vs-row>
    <vs-row>
      <vs-select autocomplete placeholder="Válasszon tej- és cukormentes menüt" label="Tej- és cukormentes" v-model="selected.IdMainC">
        <vs-select-item :value="null" text="Nincs tej- és cukormentes menü"/>
        <vs-select-item :key="index" :value="item.ItemId" :text="item.ItemName" v-for="(item, index) in itemData"/>
      </vs-select>
      <vs-input 
      v-if="selected.IdMainC" 
      placeholder="Tej- és cukormentes menü e-kereskedelmi kód" 
      v-model="DietEcommerceCodeInput"
      @input="formatEcommerceCode('MainC')"
    />
    <vs-row>
      <vs-select autocomplete placeholder="Válasszon epe kímelő menüt" label="Epe kímélő" v-model="selected.IdDiet">
        <vs-select-item :value="null" text="Nincs epe kímélő"/>
        <vs-select-item :key="index" :value="item.ItemId" :text="item.ItemName" v-for="(item, index) in itemData"/>
      </vs-select>
      <vs-input 
      v-if="selected.IdDiet" 
      placeholder="Epe kímélő menü e-kereskedelmi kód" 
      v-model="MainCEcommerceCodeInput"
      @input="formatEcommerceCode('Diet')"

    />
    </vs-row>
    </vs-row>
    <vs-row>
      <vs-select autocomplete placeholder="Válasszon extrát" label="Extra" v-model="selected.IdExtra">
        <vs-select-item :value="null" text="Nincs extra"/>
        <vs-select-item :key="index" :value="item.ItemId" :text="item.ItemName" v-for="(item, index) in itemData"/>
      </vs-select>
      <vs-input 
      v-if="selected.IdExtra" 
      placeholder="Extra e-kereskedelmi kód" 
      v-model="ExtraEcommerceCodeInput"
      @input="formatEcommerceCode('Extra')"

    />
    </vs-row>
    <vs-row>
      <vs-col vs-w="6" vs-type="flex" vs-justify="center">
        <vs-button @click="save()" color="success" type="gradient">Mentés</vs-button>
      </vs-col>
      <vs-col vs-w="6" vs-type="flex" vs-justify="center">
        <vs-button @click="del(selected.Id)" color="danger" type="gradient">Törlés</vs-button>
      </vs-col>
    </vs-row>

    <div class="centerx">
      <vs-popup classContent="addItemModal" title="Új menü cikk hozzáadása" :active.sync="addModal" @closemodal="closeModal()">
          <new_daily_item_quick></new_daily_item_quick>
      </vs-popup>
    </div>
  </vs-row>
</template>

<script>
import {axiosInstance} from "@/main";
import dayjs from "dayjs";
import 'dayjs/locale/hu';
import new_daily_item_quick from "./new_daily_item_quick.vue";

export default {
  created() {
    // Ensure itemData is loaded first
  },
  name: "new_daily_menu",
  components: {new_daily_item_quick},
  props: ['selected', 'itemData', 'dailyItem'],
  data() {
    return {
      addModal: false,
      SoupEcommerceCodeInput: '',
      MainAEcommerceCodeInput: '',
      MainBEcommerceCodeInput: '',
      MainCEcommerceCodeInput: '',
      DietEcommerceCodeInput: '',
      ExtraEcommerceCodeInput: '',
    }
  },
  watch: {
  'selected.IdMainA'(newVal) {
    if (newVal) {
      this.selected.MainAEcommerceCode = this.findEcommerceCode(newVal);
      this.MainAEcommerceCodeInput = this.selected.MainAEcommerceCode;
    } else {
      this.selected.MainAEcommerceCode = null;
    }
  },
  'selected.IdMainB'(newVal) {
    if (newVal) {
      this.selected.MainBEcommerceCode = this.findEcommerceCode(newVal);
      this.MainBEcommerceCodeInput = this.selected.MainBEcommerceCode;
    } else {
      this.selected.MainBEcommerceCode = null;
    }
  },
  'selected.IdMainC'(newVal) {
    if (newVal) {
      this.selected.MainCEcommerceCode = this.findEcommerceCode(newVal);
      this.MainCEcommerceCodeInput = this.selected.MainCEcommerceCode;
    } else {
      this.selected.MainCEcommerceCode = null;
    }
  },
  'selected.IdDiet'(newVal) {
    if (newVal) {
      this.selected.DietEcommerceCode = this.findEcommerceCode(newVal);
      this.DietEcommerceCodeInput = this.selected.DietEcommerceCode;
    } else {
      this.selected.DietEcommerceCode = null;
    }
  },
  'selected.IdExtra'(newVal) {
    if (newVal) {
      this.selected.ExtraEcommerceCode = this.findEcommerceCode(newVal);
      this.ExtraEcommerceCodeInput = this.selected.ExtraEcommerceCode;
    } else {
      this.selected.ExtraEcommerceCode = null;
    }
  }
},
  methods: {
    closeModal() {
      this.addModal = false;
      this.$emit('itemAdded');
    },
    addMenuItem() {
      this.addModal = true;
    },
    save() {
  let self = this;
  
  // First, save all ecommerce codes for items through itemController
  const savePromises = [];
  
  if (this.selected.IdSoup) {
  const soupItem = this.itemData.find(item => item.ItemId === this.selected.IdSoup);
  const soupData = {
    ItemId: this.selected.IdSoup,
    ItemName: soupItem.ItemName,
    ItemDescription: soupItem.ItemDescription,
    ItemPrice: soupItem.ItemPrice,
    ParentId: soupItem.ParentId,
    Sticky: soupItem.Sticky,
    EcommerceCode: this.SoupEcommerceCodeInput,
  };
    savePromises.push(
      axiosInstance.post('admin/itemController.php?action=edit', 
        { itemData: JSON.stringify(soupData) },
        { headers: {'Content-Type': 'multipart/form-data'} }
      )
    );
  }

  if (this.selected.IdMainA) {
    const mainAItem = this.itemData.find(item =>item.ItemId == this.selected.IdMainA)
    const mainAData = {
      ItemId: this.selected.IdMainA,
      ItemName: mainAItem.ItemName,
      ItemDescription: mainAItem.ItemDescription,
      ItemPrice: mainAItem.ItemPrice,
      ParentId: mainAItem.ParentId,
      Sticky: mainAItem.Sticky,
      EcommerceCode: this.MainAEcommerceCodeInput,
    };
    savePromises.push(
      axiosInstance.post('admin/itemController.php?action=edit', 
        { itemData: JSON.stringify(mainAData) },
        { headers: {'Content-Type': 'multipart/form-data'} }
      )
    );
  }

  if (this.selected.IdMainB) {
    const mainBItem = this.itemData.find(item =>item.ItemId == this.selected.IdMainB)
    const mainBData = {
      ItemId: this.selected.IdMainB,
      ItemName: mainBItem.ItemName,
      ItemDescription: mainBItem.ItemDescription,
      ItemPrice: mainBItem.ItemPrice,
      ParentId: mainBItem.ParentId,
      Sticky: mainBItem.Sticky,
      EcommerceCode: this.MainBEcommerceCodeInput,
    };
    savePromises.push(
      axiosInstance.post('admin/itemController.php?action=edit', 
        { itemData: JSON.stringify(mainBData) },
        { headers: {'Content-Type': 'multipart/form-data'} }
      )
    );
  }

  if (this.selected.IdMainC) {
    const mainCItem = this.itemData.find(item =>item.ItemId == this.selected.IdMainC)
    const mainCData = {
      ItemId: this.selected.IdMainC,
      ItemName: mainCItem.ItemName,
      ItemDescription: mainCItem.ItemDescription,
      ItemPrice: mainCItem.ItemPrice,
      ParentId: mainCItem.ParentId,
      Sticky: mainCItem.Sticky,
      EcommerceCode: this.MainCEcommerceCodeInput,
    };
    savePromises.push(
      axiosInstance.post('admin/itemController.php?action=edit', 
        { itemData: JSON.stringify(mainCData) },
        { headers: {'Content-Type': 'multipart/form-data'} }
      )
    );
  }

  if (this.selected.IdDiet) {
    const dietItem = this.itemData.find(item =>item.ItemId == this.selected.IdDiet)
    const dietData = {
      ItemId: this.selected.IdDiet,
      ItemName: dietItem.ItemName,
      ItemDescription: dietItem.ItemDescription,
      ItemPrice: dietItem.ItemPrice,
      ParentId: dietItem.ParentId,
      Sticky: dietItem.Sticky,
      EcommerceCode: this.DietEcommerceCodeInput,
    };
    savePromises.push(
      axiosInstance.post('admin/itemController.php?action=edit', 
        { itemData: JSON.stringify(dietData) },
        { headers: {'Content-Type': 'multipart/form-data'} }
      )
    );
  }

  if (this.selected.IdExtra) {
    const extraItem = this.itemData.find(item =>item.ItemId == this.selected.IdExtra)
    const extraData = {
      ItemId: this.selected.IdExtra,
      ItemName: extraItem.ItemName,
      ItemDescription: extraItem.ItemDescription,
      ItemPrice: extraItem.ItemPrice,
      ParentId: extraItem.ParentId,
      Sticky: extraItem.Sticky,
      EcommerceCode: this.ExtraEcommerceCodeInput,
    };
    savePromises.push(
      axiosInstance.post('admin/itemController.php?action=edit', 
        { itemData: JSON.stringify(extraData) },
        { headers: {'Content-Type': 'multipart/form-data'} }
      )
    );
  }

  // Wait for all ecommerce code updates to complete
  Promise.all(savePromises)
    .then(() => {
      // Then save the daily menu without ecommerce codes
      return axiosInstance.put('admin/dailyMenuController.php', {
        ...self.selected,
      }, {
        withCredentials: true,
      });
    })
    .then((resp) => {
      self.$vs.notify({
        title: 'Rendszerüzenet',
        position: 'top-right',
        text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
        color: resp.data.status === 'OK' ? 'success' : 'danger',
        icon: resp.data.status === 'OK' ? 'check_box' : 'error'
      });
      self.$parent.$emit('closemodal');
    })
    .catch((err) => {
      if (err.response.status === 401)
        self.$root.exterminatus(err.response.data.message);
      else {
        self.$vs.notify({
          title: 'Rendszerüzenet',
          position: 'top-right',
          text: err.response.data.message,
          color: 'danger',
          icon: 'error'
        });
      }
    });
},
    formatDate(date) {
      return dayjs(date).locale('hu').format('YYYY. MMMM. D. - dddd');
    },
    findEcommerceCode(itemId) {
    // Find the EcommerceCode for a specific item from itemData
    const item = this.itemData.find(i => i.ItemId === itemId);
    return item ? item.EcommerceCode : null;
  },
  loadDailyMenu() {
  axiosInstance
    .get('admin/dailyMenuController.php', { params: { id: this.selected.Id } })
    .then((response) => {
      this.selected = {
        ...response.data,
        SoupEcommerceCode: response.data.SoupEcommerceCode || null,
        MainAEcommerceCode: response.data.MainAEcommerceCode || null,
        MainBEcommerceCode: response.data.MainBEcommerceCode || null,
        MainCEcommerceCode: response.data.MainCEcommerceCode || null,
        DietEcommerceCode: response.data.DietEcommerceCode || null,
        ExtraEcommerceCode: response.data.ExtraEcommerceCode || null,
      };

      // Map the values to input fields
      this.SoupEcommerceCodeInput = this.selected.SoupEcommerceCode || '';
      this.MainAEcommerceCodeInput = this.selected.MainAEcommerceCode || '';
      this.MainBEcommerceCodeInput = this.selected.MainBEcommerceCode || '';
      this.MainCEcommerceCodeInput = this.selected.MainCEcommerceCode || '';
      this.DietEcommerceCodeInput = this.selected.DietEcommerceCode || '';
      this.ExtraEcommerceCodeInput = this.selected.ExtraEcommerceCode || '';
    })
    .catch((error) => {
      console.error('Error loading daily menu:', error);
    });
},
    formatEcommerceCode(type) {
      let input;
      switch(type) {
        case 'Soup':
          input = this.SoupEcommerceCodeInput;
          break;
        case 'MainA':
          input = this.MainAEcommerceCodeInput;
          break;
        case 'MainB':
          input = this.MainBEcommerceCodeInput;
          break;
        case 'MainC':
          input = this.MainCEcommerceCodeInput;
          break;
        case 'Diet':
          input = this.DietEcommerceCodeInput;
          break;
        case 'Extra':
          input = this.ExtraEcommerceCodeInput;
          break;
      }

      // Remove all characters except letters and numbers
      let sanitizedCode = input.replace(/[^a-zA-Z0-9]/g, '');
      
      // Group characters in chunks of 5 and join them with commas
      sanitizedCode = sanitizedCode.match(/.{1,5}/g)?.join(',') || '';
      
      // Update the appropriate input and selected value
      switch(type) {
        case 'Soup':
          this.SoupEcommerceCodeInput = sanitizedCode;
          this.selected.SoupEcommerceCode = sanitizedCode;
          break;
        case 'MainA':
          this.MainAEcommerceCodeInput = sanitizedCode;
          this.selected.MainAEcommerceCode = sanitizedCode;
          break;
        case 'MainB':
          this.MainBEcommerceCodeInput = sanitizedCode;
          this.selected.MainBEcommerceCode = sanitizedCode;
          break;
        case 'MainC':
          this.MainCEcommerceCodeInput = sanitizedCode;
          this.selected.MainCEcommerceCode = sanitizedCode;
          break;
        case 'Diet':
          this.DietEcommerceCodeInput = sanitizedCode;
          this.selected.DietEcommerceCode = sanitizedCode;
          break;
        case 'Extra':
          this.ExtraEcommerceCodeInput = sanitizedCode;
          this.selected.ExtraEcommerceCode = sanitizedCode;
          break;
      }
    },
  }
}
</script>

<style scoped>
.vs-input, .con-select {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
}

form {
  width: 100%;
}
</style>